<template>
  <uni-popup ref="serviceExplain" type="bottom">
    <uni-card title="互联网问诊服务说明" :is-full="true" :note="true">
      <div class="gridClass">
        <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
        <div v-html="notices" />
      </div>
      <template v-slot:footer>
        <div class="footer-box" @click="close">
          <span class="btn">确定</span>
        </div>
      </template>
      <template v-slot:close>
        <uni-icons type="closeempty" color="#666" @click="close" />
      </template>
    </uni-card>
  </uni-popup>
</template>

<script>
import { getNotices } from '@/views/funcPuzzle/utils/index.js'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      notices: ''
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.getNotice()
          this.$refs.serviceExplain.open()
        } else {
          this.close()
        }
      }
      // immediate: true
    }
  },
  methods: {
    getNotice() {
      getNotices({
        noticeCode: '17'
      }).then(rs => {
        if (rs.errCode && rs.errCode !== '0') {
          return false
        }
        this.notices = rs.NoticeList[0].noticeContext
      })
    },
    close() {
      if (!this.$refs.serviceExplain) {
        return false
      }
      this.$emit('update:visible', false)
      this.$refs.serviceExplain.close()
    },
    open() {
      this.$emit('update:visible', true)
      this.$refs.serviceExplain.open()
    }
  }
}
</script>

<style lang="scss" scoped>
.gridClass {
  padding: 0.682667rem;
}
.footer-box {
  text-align: center;
  width: 14.634667rem;
  height: 1.877333rem;
  background: #0089ff;
  border-radius: 0.938667rem;
  line-height: 1.877333rem;
  font-size: 0.682667rem;
  font-weight: 500;
  margin: 0.170667rem 0 0.341333rem 0.170667rem;
  .btn {
    color: #fff;
  }
}
</style>
